let session = window.sessionStorage, text_encoder = new TextEncoder(), key = null
let algorithim = {
   name: "HMAC",
   hash: { name: "SHA-512" }
}
let junk = '9qgwHd3ew3jO5lo1CkKOeqnz6PaN'

export default class SessionStorage {
   constructor() {
      this.generateKey()
   }

   async generateKey() {
      if (session.getItem('_id') === null) {
         key = await crypto.subtle.generateKey(algorithim, true, ["sign", "verify"]);
         console.log('Exported New Key')
         await this.exportKey(key)
      } else {
         // console.log('Exported Key')
         await this.importKey()
      }
   }

   async exportKey(key) {
      let _key = await window.crypto.subtle.exportKey("raw", key);
      _key = await this.convertToBase64(_key)
      return session.setItem('_id', _key)
   }

   async importKey() {
      let _key = await this.convertFromBase64(session.getItem('_id'))
      key = await window.crypto.subtle.importKey("raw", _key, algorithim, true, ["sign", "verify"]);
      return key
   }

   async convertToBase64(data) {
      return await btoa(String.fromCharCode.apply(null, new Uint8Array(data)));
   }

   async convertFromBase64(data) {
      return await Uint8Array.from(atob(data), c => c.charCodeAt(0)).buffer
   }

   async signData(data) {
      data = text_encoder.encode(JSON.stringify(data) + junk)
      let signature = await crypto.subtle.sign(algorithim, key, data);

      return await this.convertToBase64(signature)
   }

   async isDataAuthentic(data) {
      try {
         let signature = await this.convertFromBase64(data.signature)
         data = text_encoder.encode(JSON.stringify(data.data) + junk)

         return await crypto.subtle.verify(algorithim, key, signature, data);
      } catch (err) {
         console.log(err)
         return false
      }
   }

   async set(session_key, data) {
      // check if key is available and sign the data
      console.log('Setting: ', session_key)
      await this.generateKey()
      let signature = await this.signData(data)

      // write the data with the signature in it
      session.setItem(session_key, JSON.stringify({
         data,
         signature
      }))

      // Notify session changed
      Event.$emit('session:set', { session_key })
      return true;
   }

   async get(session_key) {
      // fetch the data
      console.log('Getting: ', session_key)
      let data = JSON.parse(session.getItem(session_key))
      if (data) {
         if (await this.isDataAuthentic(data)) {
            if (data.data) {
               Event.$emit('session:get', { session_key })
               return data.data
            } else {
               return data
            }
         } else {
            // Send tamper request and clear sessions
            await this.clear()
            // TODO: Send tamper request to server
         }
      }

      return undefined
   }

   GET(session_key) {
      let res = JSON.parse(session.getItem(session_key))

      if (res) {
         return res.data
      } else {
         return res
      }
   }

   async clear() {
      console.log('Clearing Session')

      session.clear()
      Event.$emit('session:cleared')
      return true;
   }

   remove(session_key) {
      session.removeItem(session_key)
      Event.$emit('session:removed', { session_key })
      return true;
   }
}